import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Col,
  CustomInput,
  FormGroup,
  Label,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import SearchInput from '../../../commons/SearchInput';
import { ContFilterYear, ContPaginationPage } from '../../../styled-components';
import generateYearOptions from '../../../lib/helpers/generateYearOptions';
import generateMonthOptions from '../../../lib/helpers/generateMonthOptions';
import generatePaginationOptions from '../../../lib/helpers/generatePaginationOptions';
import SignalsTable from './SignalsTable';

const MySignalsPresentational = ({
  data,
  profile,
  newIsAdmin,
  query,
  total,
  onFilter,
}) => {
  const [t] = useTranslation('SIGNALS');
  const { limit, offset } = query;

  return (
    <section>
      <TabContent activeTab={'1'}>
        <TabPane tabId="1">
          <section>
            <Row className="search-add-cont m-t-20" style={{ rowGap: '1rem' }}>
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.admin }}
                  onFilter={({ search }) => onFilter({ admin: search })}
                  label={t('ADMIN_SEARCH')}
                />
              </Col>

              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.signalman }}
                  onFilter={({ search }) => onFilter({ signalman: search })}
                  label={t('SIGNALMAN_SEARCH')}
                />
              </Col>

              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.notes }}
                  onFilter={({ search }) => onFilter({ notes: search })}
                  label={t('NOTES_SEARCH')}
                />
              </Col>

              <Col sm="12" md="6" lg="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>{t('ACCOUNTABILITY_YEAR_FILTER')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="selectAccountabilityYear"
                          name="accountabilityYear"
                          value={query && query.accountabilityYear}
                          onChange={({
                            target: { value: accountabilityYear },
                          }) => {
                            onFilter({ accountabilityYear });
                          }}
                        >
                          {generateYearOptions(true)}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>

              <Col sm="12" md="6" lg="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>{t('ACCOUNTABILITY_MONTH_FILTER')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="selectAccountabilityMonth"
                          name="accountabilityMonth"
                          disabled={!query.accountabilityYear}
                          value={query && query.accountabilityMonth}
                          onChange={({
                            target: { value: accountabilityMonth },
                          }) => onFilter({ accountabilityMonth })}
                        >
                          {generateMonthOptions()}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>
            </Row>
          </section>

          <section style={{ marginTop: '1rem' }}>
            <SignalsTable
              data={data}
              total={total}
              offset={offset}
              limit={limit}
              onFilter={onFilter}
            />

            <ContPaginationPage>
              <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

              <FormGroup>
                <CustomInput
                  type="select"
                  className="pagination-select"
                  id="perPage"
                  name="perPage"
                  value={limit}
                  onChange={({ target: { value: limit } }) => {
                    onFilter({ limit: limit });
                  }}
                >
                  {generatePaginationOptions()}
                </CustomInput>
              </FormGroup>
            </ContPaginationPage>
          </section>
        </TabPane>
      </TabContent>
    </section>
  );
};

export default MySignalsPresentational;
